exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-image-container{padding:0}@media (-ms-high-contrast:active),screen and (min-width:920px) and (-ms-high-contrast:none){.header-image-container{height:280px}}.header-container .widget-container{position:relative;left:0;top:0;width:100%;max-width:275px;height:100%}@media screen and (min-width:920px){.header-container .widget-container #widget-container{height:100%}}.subcategory-list{padding:4px;display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap}.big-image-container{width:100%;max-height:100vh;margin:0;padding:0;overflow:hidden}.big-image-container img{width:100%;height:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/routes/products.styl
// module id = 536
// module chunks = 0